module.exports = __webpack_public_path__ + "52f42842e43a8a705c6452aa0103f6f1.png";


//////////////////
// WEBPACK FOOTER
// ./statics/imgs/home/goods_bg.png
// module id = 185
// module chunks = 0